export function enforceMinMax(el: any) {
  if (el.target.value != "") {
    if (parseInt(el.target.value) < parseInt(el.target.min)) {
      el.target.value = el.target.min;
    }
    if (parseInt(el.target.value) > parseInt(el.target.max)) {
      el.target.value = el.target.max;
    }
  }
}

export const isNumericInput = (t: string) => ["decimal", "entero"].includes(t);

const inputsThatCantHasAlert = [
  "radio1",
  "radio2",
  "title",
  "subtitle",
  "normalText",
];

export const shouldRenderAlertInput = (inputProps: any) =>
  inputProps &&
  inputProps?.hasAlert &&
  inputProps?.type &&
  !inputsThatCantHasAlert.includes(inputProps.type);
